export const COMPOSE_OPEN = 'COMPOSE_OPEN'
export const COMPOSE_MINIMIZE = 'COMPOSE_MINIMIZE'
export const COMPOSE_MAXIMIZE = 'COMPOSE_MAXIMIZE'
export const COMPOSE_DELETE = 'COMPOSE_DELETE'
export const COMPOSE_CLOSE = 'COMPOSE_CLOSE'
export const TO_MOBILE = 'TO_MOBILE'
export const TO_DESKTOP = 'TO_DESKTOP'
